import styled from 'styled-components';
import color from 'tinycolor2';
import { Menu as MenuComponent } from '@pearsontechnology/aero-components';


export const HistoryListItem = styled.div`
  margin: 8px 18px 8px 18px;

  &:last-child{
    margin-bottom: 16px;
  }
`;

export const HistoryListWrapper = styled.div`
  background-color: ${(props) => color(props.theme['color.background']).setAlpha(0.7).toString()};
  max-height: ${(props) => props.showDifferences ? '700px' : '500px'};
  ${(props) => props.isScrollable && 'overflow-y: scroll;'};
  &:not(:last-child) {
    box-shadow: 0 0 0 0 rgb(0 0 0 / 5%), 0 1px 0 0 rgb(0 0 0 / 8%), 0 1px 0 0 rgb(50 50 93 / 11%);
  }
  transition: 0.8s;
  opacity: 0;
  transform: translateY(-30px);
  &.enter, &.entered {
    opacity: ${(props) => props.disabled ? '0.3' : '1'};
    ${(props) => props.disabled && `pointer-events: none;`}
    transform: translateY(0px);
  }
  &.exit, &.exited{
    opacity: 0;
  }
  &.exiting, &.entering{
    opacity: 0.1;
    background-color: transparent;
    transform: translateY(-15px);
  }
`;

export const ColumnText = styled.div`
  display:flex;
  justify-content: center;
`;

export const SubListHeader = styled.div`
  margin:24px 20px 16px 20px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const SubListHeaderActions = styled.div`
  margin: 0px 20px 16px 20px;
  line-height: 21px;
  display: flex;
  justify-content: space-between;
  align-item: centre;
`;

export const SubListHeaderActionsLeft= styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  margin-right: auto;
`;

export const SubListHeaderActionsRight= styled.div`
  margin-left: auto;
  display:flex;

  & button {
    margin-right: 5px;
  }
`;


export const DescriptionSection = styled.div`
  align-items: flex-start;
  flex-direction: column;
  display: flex;
`;

export const DeleteButton = styled.div`
  display:flex;
  cursor: pointer;
  justify-content:center;
  align-items:center;
  width:30px;
  height:30px;
`;

export const ColumnTextBold = styled.div`
  margin-bottom: 5px;
  font-weight: bold;
`;

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
  width: fit-content;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const Spacer = styled.div`
  width: 34px;
`;
